import React from 'react';
import { useSelector } from 'react-redux';
import { Video } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../lib/utils';
import type { RootState } from '../../../../reducers';

const ChatThinkingVideo = () => {
  const { t } = useTranslation();
  const thumbUrl = useSelector(
    (state: RootState) => state.selectedVideo.file?.thumbUrl,
  );

  return (
    <div className="relative flex items-start mt-2 w-full">
      <div className="flex items-center gap-3">
        <div className="relative flex-shrink-0">
          {thumbUrl ? (
            <img
              src={thumbUrl}
              alt="Video thumbnail"
              className="w-auto h-auto max-w-[200px] max-h-32 object-contain rounded-lg"
            />
          ) : (
            <div className="w-48 h-32 bg-muted-foreground/5 flex items-center justify-center rounded-lg">
              <Video className="w-12 h-12 text-muted-foreground/10" />
            </div>
          )}
          <div className={cn('absolute inset-0 overflow-hidden rounded-lg')}>
            <div
              className={cn(
                'absolute w-full',
                'bg-gradient-to-b from-transparent via-white/20 to-transparent dark:via-white/10',
                'animate-[wipe_2s_ease-in-out_infinite]',
              )}
              style={{
                background:
                  'linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
                height: '40%',
              }}
            />
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex items-center gap-1">
              {[0, 1, 2].map((index) => (
                <span
                  key={index}
                  className={cn(
                    'w-1.5 h-1.5 rounded-full bg-muted-foreground opacity-70',
                    'animate-pulse',
                  )}
                  style={{
                    animationDelay: `${index * 0.2}s`,
                    animationDuration: '1.5s',
                  }}
                />
              ))}
            </div>
          </div>
        </div>

        <span className="text-foreground text-sm">
          {t('chat.videoThinking.message')}
        </span>
      </div>
    </div>
  );
};

export default ChatThinkingVideo;
